// @flow
import API from 'common/services/api';
import Radio from 'common/domain/radio';
import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import type { RadioConfigurationStepName } from 'common/domain/RadioConfigurationStep';

class RadioConfigurationAPI {
  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async fetchStep(radio: Radio, token: string, stepName: RadioConfigurationStepName) {
    const url = `/statsradio/${radio.callSign}/configuration/${stepName.toLowerCase()}`;

    const { data } = await API.get(url, {}, { headers: this.buildHeaders(token) });

    return RadioConfigurationStep.of(stepName, data);
  }

  async saveStep(radio: Radio, token: string, step: RadioConfigurationStep) {
    const url = `/statsradio/${radio.callSign}/configuration/${step.name.toLowerCase()}`;
    const stepData = { stepName: step.name, stepData: step.data };

    return await API.put(url, stepData, { headers: this.buildHeaders(token) });
  }

  async uploadPlayerImage(callSign: string, token: string, imageType: string, image: any): Promise<string> {
    const url = `/statsradio/${callSign}/configuration/player/${imageType}`;

    const formData = new FormData();
    formData.append(imageType, image);

    const headers = {
      ...this.buildHeaders(token),
      'Content-Type': 'multipart/form-data',
    };

    const { data } = await API.post(url, formData, { headers: headers });

    return data.url;
  }
}

export default new RadioConfigurationAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/services/RadioConfigurationAPI.js